import React from 'react';
import { useTranslation } from 'react-i18next';
import { useCompletedMessage } from '../../hooks/useCompletedMessage';
import { AlertInline } from '@eds-web/react';

export const CompletedPrize: React.FC<{
    isCash: boolean;
    isOffline: boolean;
    isFRMinor: boolean;
}> = ({ isCash, isOffline, isFRMinor }) => {
    const { t } = useTranslation();
    const message = useCompletedMessage(isCash, isOffline, isFRMinor);
    const title = t('epic.esport.stepComplete.title');

    return (
        <AlertInline
            style={{ marginBottom: 24 }}
            status={'success'}
            message={message}
            title={title}
        />
    );
};
